import _ from 'lodash';
import { useEffect, useCallback, useState } from 'react';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { proactiveCareyManager } from 'services/ProactiveCareyService';
import { useCPPContext } from '../components/Patient/CPP/CPPContext';
import { store } from 'careand-redux/store';

export function useProactiveCarey(
  patientId: string | undefined,
  appointmentId: string | undefined,
) {
  const dispatch = useAppDispatch();
  const [isActive, setIsActive] = useState(false);
  const { unreactiveNoteValue } = useCPPContext();

  useEffect(() => {
    if (!appointmentId || !patientId) return;

    if (!isActive) {
      proactiveCareyManager.stopForAppointment(appointmentId);
      return;
    }

    // Start polling for this appointment
    // Use store.getState instead of capturing state in closure
    proactiveCareyManager.startForAppointment(
      patientId,
      appointmentId,
      unreactiveNoteValue,
      dispatch,
      () => store.getState(),
    );

    // Cleanup on unmount
    return () => {
      proactiveCareyManager.stopForAppointment(appointmentId);
    };
  }, [appointmentId, dispatch, isActive, patientId]);

  const start = useCallback(() => setIsActive(true), []);
  const stop = useCallback(() => setIsActive(false), []);

  const runOnce = useCallback(
    (instructions?: string) => {
      if (!appointmentId || !patientId) {
        return;
      }
      proactiveCareyManager.runOnceForAppointment(
        instructions,
        patientId,
        appointmentId,
        unreactiveNoteValue,
        dispatch,
        () => store.getState(),
      );
    },
    [appointmentId, dispatch],
  );

  return { start, stop, runOnce };
}
